<template>
  <div class="video-list">
    <div v-if="show">
      <van-collapse v-model="activeCollapse" accordion v-if="show">
        <van-collapse-item v-for="(item, index) in videos" :key="item.videoHdUrl" :title="item.name" :name="`video_${index}`" class="item">
          <div class="mask" @click="handleClick(item)"></div>
          <IframeVideo :url="item.videoHdUrl" />
        </van-collapse-item>
      </van-collapse>
      <pageToast ref="pageToast" />
    </div>
  </div>
</template>

<script>
// 引入视频组件
import ezuikit from "@/utils/ezuikit";
import IframeVideo from "./iframe";

export default {
  components: {
    IframeVideo
  },
  props: {
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    online: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      videos: [],
      no: localStorage.getItem("no"),
      isLoading: false,
      show: true,
      activeCollapse: "video_0"
    };
  },

  watch: {
    online (v) {
      this.getThirdCamera();

      // if (v) {
      //   this.show = true;
      //   this.getThirdCamera();
      // } else {
      //   this.show = false;
      //   this.$toast.fail("设备离线中");
      // }
    },

    hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem("no");
        this.no = no;
        this.getThirdCamera(no);
      }
    },

    refreshing (bl) {
      bl && this.onRefresh();
    }
  },

  mounted () {
    const no = localStorage.getItem("no");
    this.no = no;
    this.getThirdCamera(no);
  },

  methods: {
    // 获取第三方摄像头
    async getThirdCamera (no = this.no) {
      console.log("getThirdCamera");
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });

      await this.$api
        .getThirdCamera({ gatewayNo: no })
        .then(res => {
          try {
            this.$toast.clear();
            let token = res.accessToken;

            if (!this.$isblank(res.videos)) {
              this.$refs.pageToast && (this.$refs.pageToast.type = 0);
              this.videos = res.videos.map(item => {
                return {
                  ...item,
                  videoHdUrl: `https://open.ys7.com/ezopen/h5/iframe?url=${item.videoHdUrl}&accessToken=${token}`
                };
              });


              console.log("this.videos:", this.videos);
            } else {
              this.$refs.pageToast && (this.$refs.pageToast.type = 1);
            }
          } catch (err) {
            console.error("err222:", err);
          }
        })
        .catch(err => {
          this.$refs.pageToast && (this.$refs.pageToast.type = 1);
          this.$toast.clear();
        });
    },

    async onRefresh () {
      this.isLoading = true;
      await this.getThirdCamera(this.no);
      this.isLoading = false;
    },

    handleClick (data) {
      console.log("data:", data);
      this.$router.push({
        path: "/videoPlay",
        query: {
          url: data.videoHdUrl,
          channelNo: data.channelNo,
          ysNo: data.ysNo
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.video-title {
  font-size: 0.32rem;
}

/deep/ .van-collapse-item__content {
  position: relative !important;
}

.item {
  position: relative;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
